module.exports = __webpack_public_path__ + "img/PROBESHIELDSTENPACKS.a2f23a14.jpg";